import { createFileRoute } from "@tanstack/react-router";
import { DiscoverSectionPage } from "../../../features/discover/pages/discover-section-page";

/** The chat itself: rail, chat and the map that re-pins onto each answer. */
export const Route = createFileRoute("/$lang/_layout/ai-chat")({
  component: () => (
    <DiscoverSectionPage
      mode="chat"
      canonicalOf="ai-travel-planner"
      titleKey="ai_chat_page.seo_title"
      descriptionKey="ai_chat_page.seo_description"
    />
  ),
});
